export default "__VITE_ASSET__xCHoRqZO__"